<div class="tw-flex tw-flex-col tw-bg-dt-surface-card tw-rounded-b-xl">
  <div class="tw-px-5 tw-py-8 tw-h-full">
    <form>
      <app-input
        [value]="form.controls.classificationName.value"
        [label]="'classificationName' | i18n"
        [isRequired]="true"
        [placeholder]=""
        (outputValue)="onClassificationNameChange($event)"
      >
      </app-input>
    </form>
  </div>
  <div class="tw-flex tw-bg-dt-surface-elevated tw-py-6 tw-px-8 tw-rounded-b-xl tw-justify-end">
    <app-gloss-button
      class="tw-w-1/2 xs:tw-w-full"
      [options]="saveButtonOptions"
    ></app-gloss-button>
  </div>
</div>
